<template lang="pug">
.seller-chooser-core.d-flex.flex-column.not-scrollable.flex-fill
  //- .sticky-top.bg-white
  template(v-if='hideTitle !== true')
    .d-flex.justify-content-center.align-items-center.border-bottom.py-3(style='min-height: 82px;')
      .action-icon.rounded-circle
        img(src='@/assets/menu-item-icon.svg')
      h5.mb-0.font-weight-normal.ml-3 เลือกเซลล์

  .py-3.px-4
    CustomSearchBox.w-100(
      v-model='filterSearch' placeholder='ค้นหาด้วยชื่อ' width='100%'
      :isLoading='isLoading'
    )
      i.fa.fa-search
  hr.m-0

  LoadedContentWrapper.flex-fill.scrollable(
    :isLoading='isLoading'
    :data='listData'
    @reload='loadData()'
  )
    .sell-record-list
      template(v-for='(entry, i) in filteredListData')
        .transparent-button.no-scaling(
          style='min-height: auto;'
          @click='onSellerSelected(entry, pageFirstRowIndex + i)'
          :class="{ 'selected': !multiSelect && isSellerSelected(i) }"
        )
          .d-flex.px-3.mx-1.py-3
            template(v-if='multiSelect')
              .check-container.mr-4(:class="{'is-active': isSellerSelected(pageFirstRowIndex + i)}")
                .check
            img.rounded-circle(
              :src='entry.imgSrc' width='56' height='56'
            )
            div.ml-3
              .text-19 {{ `${entry.name}` }}
              //- .text-19 {{ `${entry.firstName} ${entry.lastName}` }}
              .text-17
                | เขต {{ `${entry.zone}` }}
              .text-17.mt-2
                i.fa.fa-phone.mr-2
                | {{ entry.telephone }}
          hr.m-0

  hr.m-0
  .px-4.py-3
    CustomPaginationSuperCompact(
      v-model='currentPage'
      :total='totalPage'
      :compact='true'
    )
</template>

<script>
/* eslint-disable arrow-body-style, no-unused-vars */
import FancyHeader from '@/components/profile-performance/FancyHeader.vue';

export default {
  props: {
    value: {},
    hideTitle: {},

    multiSelect: {
      default: false,
    },

    selectedSellersIndex: {
      default: () => [],
    },
  },
  watch: {
    value() { this.selectedSellers = this.value; },
    selectedSellers() { this.$emit('input', this.selectedSellers); },
    selectedSellersIndex() { this.$emit('selectedIndexChanged', this.selectedSellersIndex); },

    // props
    // preSelectedSellersIndex() {
    // },

    multiSelect() {
      if (this.multiSelect === false) {
        const lastSelected = this.selectedSellers[this.selectedSellers.length - 1];
        this.selectedSellers = [lastSelected];
      }
    },

    // reload data
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  components: {
    FancyHeader,
  },
  computed: {
    filteredListData() {
      // if (this.listData) {
      //   const KEYWORD = this.filterSearch.trim().toUpperCase();
      //   return this.listData.filter((item, i) => {
      //     return !KEYWORD || (
      //       item.name.toUpperCase().includes(KEYWORD)
      //       || item.username.toUpperCase().includes(KEYWORD)
      //       || item.telephone.toUpperCase().startsWith(KEYWORD)
      //     );
      //   });
      // }
      // return [];
      return this.listData;
    },
  },
  data: () => ({
    isLoading: false,

    filterDate: '',
    filterSearch: '',
    listData: [
      // {
      //   name: 'บริษัท ซาฟารีเวิลด์ จำกัด (มหาชน)',
      //   entryNo: 'AB636789090',
      // },
    ],

    // pagination
    currentPage: 1,
    totalPage: 0,
    totalRows: 0,
    pageFirstRowIndex: 1,

    selectedSellers: [],
    // selectedSellersIndex: [],
  }),
  mounted() {
    if (this.value) { this.selectedSellers = this.value; }
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.listData = null;

      // load data
      try {
        const res = await this.$api.admin.sellerRecords.sellerList(
          this.currentPage,
          this.filterSearch,
        );
        if (res.status === 200) {
          this.listData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          // this.totalPage = 5;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.listData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    formatDate(dateString) {
      return this.$moment(dateString).format('DD/MM/YYYY');
    },

    isSellerSelected(i) {
      // MULTI-SELECT
      if (this.multiSelect === true) {
        return this.selectedSellersIndex.includes(i);
      }

      // SINGLE-SELECT
      const s1 = this.selectedSellers[0]; // the selected seller
      const s2 = this.filteredListData[i]; // item in question
      let result;
      if (!s1 || !s2) {
        result = false;
      } else {
        result = (
          s1.id === s2.id
          && s1.created_at === s2.created_at
          && s1.updated_at === s2.updated_at
        );
      }
      return result;
    },

    onSellerSelected(seller, i) {
      if (this.multiSelect === true) {
        if (!this.selectedSellers) {
          this.selectedSellers = [];
        }

        const j = this.selectedSellersIndex.indexOf(i);
        // alert(j);
        if (j === -1) {
          this.selectedSellers.push(seller);
          this.selectedSellersIndex.push(i);
        } else {
          this.selectedSellers.splice(j, 1);
          this.selectedSellersIndex.splice(j, 1);
        }
      } else {
        this.selectedSellers = [seller];
      }
    },
  },
};
</script>

<style lang="scss">
.seller-chooser-core {
  .sell-record-list {
    min-height: 100px;
  }
}
</style>
